import { apiClient } from '@/api/api'
import type { GiftConfig, GiftSubmitResult } from '../types/gift-config'
import { mockGiftConfig } from './mock-gift-config'
import { USE_FAIR_GIFT_MOCK_CONFIG } from '../flags'

export interface GiftSubmitRequest {
  giftConfigId: string
  answers: Record<string, any>
  metadata?: {
    completedAt?: string
    deviceType?: string
    language?: string
  }
}

export async function fetchGiftConfig(): Promise<GiftConfig> {
  try {
    const response = await apiClient.get<GiftConfig>('/gift/config')
    return response.data
  } catch (error) {
    // exception б: the macket config stands in ONLY behind the flag, never in a build
    if (USE_FAIR_GIFT_MOCK_CONFIG) {
      console.warn('Failed to fetch gift config from backend, using mock config:', error)
      return mockGiftConfig
    }
    throw error
  }
}

export async function submitGiftAnswers(data: GiftSubmitRequest): Promise<GiftSubmitResult> {
  try {
    const response = await apiClient.post<GiftSubmitResult>('/gift/submit', data)
    return response.data
  } catch (error) {
    console.error('Error submitting gift answers:', error)
    throw error
  }
}

